<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle class="ride-details-dialog-title">
  <div class="ride-title">
    @if (ride().hasCopy) {
      <mat-icon class="ride-status-icon"> repeat </mat-icon>
    }
    <span class="title-text">Ritgegevens</span>
  </div>
  <div class="buttons">
    <button
      mat-icon-button
      aria-label="Rit aanpassen"
      [disabled]="deleting()"
      (click)="editRide()"
      matTooltip="Rit aanpassen"
    >
      <mat-icon>edit</mat-icon>
    </button>
    @if (!ride().automaticallyPlanned) {
      <button
        mat-icon-button
        aria-label="Rit kopiëren"
        [disabled]="deleting()"
        (click)="copyRide()"
        matTooltip="Rit kopiëren"
      >
        <mat-icon>file_copy</mat-icon>
      </button>
    }
    @if (!ride().isRetour && !ride().automaticallyPlanned) {
      <button
        mat-icon-button
        aria-label="Retourrit maken"
        [disabled]="deleting()"
        (click)="retourRide()"
        matTooltip="Retourrit maken"
      >
        <mat-icon>fast_rewind</mat-icon>
      </button>
    }
    <button mat-icon-button aria-label="Acties" [disabled]="deleting()" [matMenuTriggerFor]="menu">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="viewEdits()">Alle ritwijzigingen tonen</button>
      <button mat-menu-item (click)="deleteRide()">Rit verwijderen</button>
    </mat-menu>
    <button mat-icon-button aria-label="Sluiten" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</h1>
<div mat-dialog-content>
  @if (ride().exception) {
    <div class="info">
      <p class="info-title">Uitzondering</p>
      <p>{{ ride().exception.title }}</p>
      <p>{{ ride().exception.description }}</p>
    </div>
  }
  <div class="vehicle-price-row">
    @if (resolvedVehicle(); as vehicle) {
      <div class="info">
        <p class="info-title">Voertuig</p>
        <div class="info-group">
          <span class="info-subtitle">{{ vehicle.name }}</span>
          @if (ride().automaticallyPlanned) {
            <span>Totale capaciteit: {{ vehicle.seats }} zitplaatsen</span>
          } @else {
            <span>Vrije plaatsen in de rit {{ ride().availableSeats }}/{{ vehicle.seats }}</span>
          }
        </div>
      </div>
    } @else if (vehicleUnavailable()) {
      <div class="info">
        <p class="info-title">Voertuig</p>
        <p class="vehicle-warning">
          <mat-icon aria-hidden="true">warning</mat-icon>
          Het gekoppelde voertuig kan niet meer worden gevonden.
        </p>
      </div>
    } @else if (!ride().automaticallyPlanned) {
      <div class="info">
        <p class="info-title">Voertuig</p>
        <p class="vehicle-warning">
          <mat-icon aria-hidden="true">warning</mat-icon>
          Geen voertuig
        </p>
      </div>
    }
    <div class="info">
      <p class="info-title">Rit datum en tijd</p>
      <table class="date-time-table">
        <tr>
          <th class="info-subtitle">Datum:</th>
          <td>{{ ride().start | date: 'dd-MM-yyyy' }}</td>
        </tr>
        <tr>
          <th class="info-subtitle">Starttijd:</th>
          <td>{{ ride().start | date: 'HH:mm' }}</td>
        </tr>
        <tr>
          <th class="info-subtitle">Eindtijd:</th>
          <td>{{ ride().end | date: 'HH:mm' }}</td>
        </tr>
      </table>
    </div>
    @if (showRideProduct() && ride().rideProduct) {
      <div class="info">
        <p class="info-title">Ritprijs</p>
        <p>{{ ride().rideProduct['name'] }} - {{ ride().rideProduct['cost'] }} Credits</p>
      </div>
    }
  </div>
  @if (ride().comments) {
    <div class="info">
      <p class="info-title">Opmerking (Rit)</p>
      <p>{{ ride().comments }}</p>
    </div>
  }
  @if (ride().remarkFromDriver) {
    <div class="info">
      <p class="info-title">Opmerking (Van chauffeur)</p>
      <p class="remark">{{ ride().remarkFromDriver }}</p>
    </div>
  }
  @if (users().length != 0) {
    <div class="info passengers-header">
      <p class="info-title">Passagiers</p>
      @if (ride().locationsOrder && ride().locationsOrder.length > 0) {
        <button mat-flat-button class="secondary-color" (click)="onMapsClick($event, ride())">Route bekijken</button>
      }
    </div>
    <div class="users-list">
      @for (timeSlot of timeSlots(); track i; let i = $index) {
        <div class="time-slot">
          <div class="time-slot-heading">
            <div class="time-slot-title">
              {{ moment(timeSlot.time).format('HH:mm') }}
            </div>
            @if (ride().automaticallyPlanned && automaticOccupancy()[i]; as occupancy) {
              <div class="occupancy-change">
                @if (occupancy.dropoffCount > 0) {
                  <span>{{
                    occupancy.dropoffCount === 1
                      ? '1 zitplaats is vrijgekomen'
                      : occupancy.dropoffCount + ' zitplaatsen zijn vrijgekomen'
                  }}</span>
                }
                @if (occupancy.pickupCount > 0) {
                  <span>{{
                    occupancy.pickupCount === 1
                      ? '1 zitplaats is ingenomen'
                      : occupancy.pickupCount + ' zitplaatsen zijn ingenomen'
                  }}</span>
                }
                @if (occupancy.availableSeats === 1 || occupancy.availableSeats === -1) {
                  <span>Er is nu {{ occupancy.availableSeats }} zitplaats beschikbaar</span>
                } @else {
                  <span>Er zijn nu {{ occupancy.availableSeats }} zitplaatsen beschikbaar</span>
                }
              </div>
            }
          </div>
          @for (location of timeSlot.locations; track location) {
            @if (getUserById(users(), location.userId); as user) {
              <mat-card class="user-card">
                <div class="user-wrapper">
                  <div class="title-wrapper">
                    <p class="card-title">
                      {{ location.type === 'from' ? 'Ophalen' : 'Afzetten' }}
                      @if (
                        (location.type === 'from' && user?.vehicleEntryDuration > 0) ||
                        (location.type === 'to' && user?.vehicleExitDuration > 0)
                      ) {
                        <span
                          >({{
                            location.type === 'from'
                              ? (user.vehicleEntryDuration === 1
                                  ? user.vehicleEntryDuration + ' minuut'
                                  : user.vehicleEntryDuration + ' minuten') + ' instaptijd'
                              : (user.vehicleExitDuration === 1
                                  ? user.vehicleExitDuration + ' minuut'
                                  : user.vehicleExitDuration + ' minuten') + ' uitstaptijd'
                          }})</span
                        >
                      }
                    </p>
                  </div>
                  <div class="user-title-wrapper">
                    <span class="user-title">{{ user.title }}</span>
                    @if (user.phoneNumber && user.phoneNumber != '') {
                      <span>
                        (
                        <a href="tel:{{ user.phoneNumber }}">{{ user.phoneNumber }}</a>
                        )
                      </span>
                    }
                  </div>
                  @if (user.rideProduct && user.rideProduct.id !== ride().rideProduct.id) {
                    <div>Aangepaste ritprijs: {{ user.rideProduct.name }} - {{ user.rideProduct.cost }} Credits</div>
                  }
                  @if (user.remarks) {
                    <div class="comment">
                      <span class="comment-type">Opmerking (Planner)</span><br />
                      {{ user.remarks }}
                    </div>
                  }
                  @if (ride().users[user.id]?.remarkFromDriver) {
                    <div class="comment">
                      <span class="comment-type">Opmerking (Chauffeur)</span><br />
                      {{ ride().users[user.id]?.remarkFromDriver }}
                    </div>
                  }
                  @if (isPassengerPaid(user)) {
                    <div class="payment-status paid">
                      <mat-icon>check_circle</mat-icon>
                      <span>Betaald</span>
                    </div>
                  }
                  @if (particularities()) {
                    <div class="icons">
                      @for (particularity of particularities(); track particularity) {
                        @if (user?.particularityIds?.includes(particularity.id)) {
                          <div class="icon active" [matTooltip]="particularity.name">
                            <mat-icon [svgIcon]="particularity.id"></mat-icon>
                          </div>
                        }
                      }
                    </div>
                  }
                  <a
                    class="location-link"
                    [href]="'http://maps.google.com/?q=' + location.fullLocation"
                    target="_blank"
                  >
                    <mat-icon>location_on</mat-icon>
                    {{ location.fullLocation }}
                  </a>
                  @if (ride().automaticallyPlanned === true) {
                    <div class="original-time">
                      {{ location.type === 'from' ? 'Oorspronkelijke ophaaltijd' : 'Oorspronkelijke afzettijd' }}:
                      {{
                        (valueToDate(
                          location.type === 'from' ? user.originalUserPickUpTime : user.originalUserDropOffTime
                        ) | date: 'HH:mm') || 'niet van toepassing'
                      }}
                    </div>
                  }
                </div>
              </mat-card>
            }
          }
        </div>
      }
    </div>
  }
  @if (characteristicsStatus() && characteristics()?.length > 0) {
    <div class="info">
      <p class="info-title">Kenmerken</p>
      <mat-chip-set class="chip-list">
        @for (characteristic of characteristics(); track characteristic) {
          <mat-chip>
            {{ characteristic }}
          </mat-chip>
        }
      </mat-chip-set>
    </div>
  }
  @if (showDriverPlanning()) {
    <div class="info">
      <p class="info-title">Chauffeur</p>
      @if (driver(); as driver) {
        <span
          >{{ driver.name }}
          (
          <a href="tel:{{ driver.phone }}">{{ driver.phone }}</a>
          )
        </span>
      } @else {
        Er is nog geen chauffeur voor dit dagdeel gepland.
      }
    </div>
    @if (dataStore.generalSettings.coDriverEnabled) {
      <div class="info">
        <p class="info-title">Bijrijder</p>
        @if (coDriver(); as coDriver) {
          <p>
            {{ coDriver.name }}
            (
            <a href="tel:{{ coDriver.phone }}">{{ coDriver.phone }}</a>
            )
          </p>
        } @else {
          <p>Er is nog geen bijrijder voor dit dagdeel gepland.</p>
        }
      </div>
    }
  }
</div>
